import React, { useState, useEffect } from 'react';
import { Checkbox, Form } from 'antd';
import moment from 'moment';
import {
 ConnectHeader,
 ConnectName,
 ConnectPeriod,
 Header,
 InputIndication,
 TableReading,
 Underline,
 SubmitButton,
} from '../../MeteringDevices.styled';
import Snackbar from '@mui/material/Snackbar';
import { Alert, AlertColor } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { TooltipProps, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { DisabledByDefault, Height } from '@mui/icons-material';
import Link from '@mui/material/Link';
import { AppDispatch } from '../../../../store/store';
import { useDispatch } from 'react-redux';
import { openDialogMeteringDeviceAdditional } from '../../../../store/reducers/openDialogMeteringDeviceAdditionalSlice';

const useStyles = makeStyles({
 typography: {
  color: '#FFB614',
  borderRadius: '5px',
  height: '8px',
  marginTop: '-20px',
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
 },
});

export default function TableMetering({
 connect,
 meterings,
 isLoading,
 form,
 isSubmiting,
}) {
 const [currentValue, setCurrentValue] = useState<number>();
 const [currentColorValue, setCurrentColorValue] = useState([
  {
   index: 0,
   color: '',
   backgroundColor: '',
   value: 0,
  },
 ]);
 const [checked, setChecked] = useState({});
 const [value, setValue] = useState<number>();
 const [showButton, setShowButton] = useState<boolean>(true);
 const [snackBarOpened, setSnackBarOpened] = useState(false);
 const [snackBarMessage, setSnackBarMessage] = useState('');
 const [snackBarType] = useState<AlertColor>('error');

 const dispatch = useDispatch<AppDispatch>();

 let processData = sessionStorage.getItem('isProcess')
  ? Boolean(sessionStorage.getItem('isProcess'))
  : false;

 const onChange = (value) => {
  setChecked(value);

  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true)),
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));
 };

 useEffect(() => {
  form.resetFields();

  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true)),
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));
 }, []);

 useEffect(() => {
  processData = sessionStorage.getItem('isProcess')
   ? Boolean(sessionStorage.getItem('isProcess'))
   : false;
 }, [sessionStorage]);

 useEffect(() => {
  sessionStorage.removeItem('meteringForm');
  form.resetFields();

  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true)),
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));
 }, [connect]);

 useEffect(() => {
  if (connect && connect.inputPeriodStart && connect.inputPeriodStop) {
   const currentDate = new Date();

   const isDate1Between = moment(currentDate).isBetween(
    connect.inputPeriodStart,
    connect.inputPeriodStop,
   );

   if (isDate1Between) {
    setShowButton(true);
   } else {
    setShowButton(false);
    setSnackBarMessage(`Период передачи показаний завершен`);
    setSnackBarOpened(true);
   }
  } else {
   setShowButton(false);
   setSnackBarMessage(`Период передачи показаний завершен`);
   setSnackBarOpened(true);
  }
 }, [connect, meterings]);

 const handleSnackBarClose = () => {
  setSnackBarMessage(``);
  setSnackBarOpened(false);
 };

 const currentValueVolume = (e: number, index: number, record: any) => {
  sessionStorage.setItem(
   'meteringForm',
   JSON.stringify(form.getFieldsValue(true)),
  );

  setValue(JSON.parse(sessionStorage.getItem('meteringForm')));

  setCurrentValue(e);
  createNewArr(meterings);

  let obj = {
   backgroundColor: '#7db457',
   index: index,
   color: 'black',
   value: e,
  };

  const data = currentColorValue.filter((x: any) => x.index !== index);

  const datePrevious = moment(record?.previousScaleReadingsDate);
  const dateCurrent = moment();
  const daysBetween = dateCurrent.diff(datePrevious, 'days');

  if (daysBetween && daysBetween !== 0) {
   const currentAverageConsumption =
    (e - record?.previousScaleReadings) / daysBetween;

   if (record.averageDailyConsumption && record.averageDailyConsumption !== 0) {
    let diflection =
     ((currentAverageConsumption - record.averageDailyConsumption) /
      record.averageDailyConsumption) *
     100;

    if (diflection <= 25) {
     obj = {
      backgroundColor: '#7db457',
      index: index,
      color: 'black',
      value: 0,
     };
    }

    if (diflection > 25 && diflection <= 50) {
     obj = {
      backgroundColor: '#ffc000',
      index: index,
      color: 'black',
      value: 25,
     };
    }

    if (diflection > 50) {
     obj = {
      backgroundColor: '#ff1717',
      index: index,
      color: 'white',
      value: 50,
     };
    }
   } else {
    obj = {
     backgroundColor: 'white',
     index: index,
     color: 'black',
     value: -1,
    };
   }
  } else {
   obj = {
    backgroundColor: 'white',
    index: index,
    color: 'black',
    value: -1,
   };
  }

  if (!record || !record?.priceFare) {
   obj = {
    backgroundColor: 'white',
    index: index,
    color: 'black',
    value: -1,
   };
  }

  data.push(obj);
  setCurrentColorValue(data);
 };

 const groupedDevices: Record<string, Models.MeteringDevices[]> =
  meterings?.reduce((result, item) => {
   if (result[item.meteringDeviceId] != null) {
    result[item.meteringDeviceId].push(item);
   } else {
    result[item.meteringDeviceId] = [item];
   }
   return result;
  }, {});

 const check =
  value &&
  value !== undefined &&
  value !== null &&
  Object.values(value) !== undefined &&
  Object.values(value) !== null &&
  Object.values(value)?.length &&
  Object.values(groupedDevices)?.every((group) => {
   if (group.length === 1) return true;
   const values = group?.map((item) => {
    const index = meterings?.indexOf(item);
    return value[`volume-${index}`];
   });
   return (
    values?.every((v) => v !== null && v !== undefined && v !== '') ||
    values?.every((v) => v === null || v === undefined || v === '' || v === 0)
   );
  });

 const createNewArr = (data) => {
  return data
   .reduce((result, item) => {
    if (result.indexOf(item.meteringDeviceId) < 0) {
     result.push(item.meteringDeviceId);
    }
    return result;
   }, [])
   .reduce((result, name) => {
    const children = data.filter((item) => item.meteringDeviceId === name);
    result = result.concat(
     children.map((item, index) => ({
      ...item,
      rowSpan: index === 0 ? children.length : 0,
     })),
    );
    return result;
   }, []);
 };

 const calculateColor = (type: number, value: string) => {
  const formattedStartTime = moment(new Date()).toDate();
  formattedStartTime.setHours(0);
  formattedStartTime.setMinutes(0);
  formattedStartTime.setSeconds(0);
  const readyStartTime = moment(formattedStartTime).add(3, 'M');

  const formattedEndTime = moment(value).toDate();
  formattedEndTime.setHours(0);
  formattedEndTime.setMinutes(0);
  formattedEndTime.setSeconds(0);
  const readyEndTime = moment(formattedEndTime);

  let color = 'white';

  if (readyEndTime.isBefore(readyStartTime)) {
   if (type === 0) {
    color = '#FFA07A';
   }

   if (type === 1) {
    color = 'black';
   }
  } else {
   if (type === 0) {
    color = 'white';
   }

   if (type === 1) {
    color = 'black';
   }
  }

  return color;
 };

 const checkDisable = (record: any) => {
  if (record?.askue && Boolean(record?.askue)) {
   return true;
  }
  return !showButton;
 };

 const handleLinkClick = () => {
  /**
   * пока не давать возможность нажимать.
   */
  dispatch(openDialogMeteringDeviceAdditional(true));
 };

 const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
 ))(({ theme }) => ({
  [`&.${tooltipClasses.popper}`]: {
   paddingTop: '10px',
   zIndex: 1000000,
  },
  [`& .${tooltipClasses.tooltip}`]: {
   backgroundColor: 'black',
   color: 'white',
   borderRadius: '5px',
   width: '500px',
   maxWidth: '500px',
   minHeight: 'auto',
   fontSize: '10px !important',
   padding: '6px 14px',
   textAlign: 'left',
   boxSizing: 'border-box',
  },
 }));

 // 1. Проверяем, есть ли во всем массиве данных хотя бы одно устройство с АСКУЭ.
 // Замените `dataSource` на имя вашей переменной с массивом строк таблицы.
 const hasAskueData = meterings?.some((record: any) => Boolean(record?.askue));

 const columns = [
  {
   title: 'Заводской номер ПУ',
   dataIndex: ['meteringDeviceNumber'],
   render(_, record) {
    return {
     children: record.meteringDeviceNumber,
    };
   },
  },
  {
   title: 'Тип ПУ',
   dataIndex: ['meteringDeviceType'],
   render(_, record) {
    return {
     children: record.meteringDeviceType,
    };
   },
  },
  {
   title: 'АСКУЭ',
   dataIndex: ['askue'],
   render(_, record) {
    return {
     children: Boolean(record.askue) ? (
      <HtmlTooltip
       placement="bottom"
       title={
        <Typography
         color="inherit"
         style={{ fontSize: '14px', lineHeight: '20px' }}
        >
         Установлен интеллектуальный ПУ (АСКУЭ). Передача показаний
         осуществляется без участия потребителя.
        </Typography>
       }
      >
       <span style={{ display: 'inline-flex', marginTop: '4px' }}>
        <CheckCircleOutlineIcon
         style={{ color: 'green', height: '25px', width: '25px' }}
        />
       </span>
      </HtmlTooltip>
     ) : null,
    };
   },
  },
  {
   title: 'Вид ресурса',
   dataIndex: ['energyType'],
   render(_, record) {
    return {
     children: record.energyType,
    };
   },
  },
  {
   title: 'КТТ',
   dataIndex: ['transformationRatio'],
   render(_, record) {
    return {
     children: record.transformationRatio,
    };
   },
  },
  {
   title: 'Шкала',
   dataIndex: ['scale'],
  },
  {
   title: 'Дата следующей поверки',
   dataIndex: ['dataNext'],
   render: (_, record) => {
    return {
     children: (
      <div
       style={{
        color: calculateColor(1, record.dataNext),
        backgroundColor: calculateColor(0, record.dataNext),
       }}
      >
       {record.dataNext ? moment(record.dataNext).format('DD.MM.YYYY') : ''}
      </div>
     ),
    };
   },
  },
  {
   title: 'Дата предыдущих показаний',
   dataIndex: ['previousScaleReadingsDate'],
   render: (_, record) => {
    return {
     children: moment(record.previousScaleReadingsDate).format('DD.MM.YYYY'),
    };
   },
  },
  {
   title: 'Предыдущее показание',
   dataIndex: ['previousScaleReadings'],
  },
  {
   title: 'Текущее показание',
   dataIndex: ['currentReading'],
   render: (_, record, index) => (
    <Form.Item name={`volume-${index}`} rules={[{ required: false }]}>
     <InputIndication
      size="small"
      parser={(value) => value.replace(',', '.')}
      placeholder="Введите показание"
      value={currentValue}
      disabled={checkDisable(record)}
      onChange={(value) => {
       currentValueVolume(value, index, record);
      }}
     />
    </Form.Item>
   ),
  },
  {
   title: 'Текущий расход',
   dataIndex: ['currentConsumption'],
   DisabledByDefault,
   render: (_, record, index) => {
    const diff =
     value && value[`volume-${index}`]
      ? value[`volume-${index}`] - record.previousScaleReadings
      : 0;
    const zero = value && value[`zero-${index}`] ? value[`zero-${index}`] : 0;
    let maxMeteringNumber: string = '';
    let transitionZero = 0;

    if (zero && value && value[`volume-${index}`]) {
     if (record.meteringDeviceSignificance) {
      for (let i = 0; i < record.meteringDeviceSignificance; i++) {
       maxMeteringNumber = maxMeteringNumber + '9';
      }
      transitionZero =
       Number(maxMeteringNumber) -
       record.previousScaleReadings +
       value[`volume-${index}`];
     }
    }
    return (
     <div
      style={{
       color: currentColorValue.filter((x) => x.index === index)[0]?.color,
       backgroundColor: currentColorValue.filter((x) => x.index === index)[0]
        ?.backgroundColor,
      }}
     >
      {currentColorValue.filter((x) => x.index === index)[0]?.value > 0 ? (
       <HtmlTooltip
        placement="bottom"
        title={
         <Typography
          color="inherit"
          style={{ fontSize: '14px', lineHeight: '20px' }}
         >
          <label>
           {`Превышение среднесуточного расхода более ${currentColorValue.filter((x) => x.index === index)[0]?.value}%`}
          </label>
         </Typography>
        }
       >
        <span style={{ display: 'inline-flex', marginTop: '4px' }}>
         {!value || value === null || value[`volume-${index}`] === undefined
          ? 0
          : record.transformationRatio === null ||
              record.transformationRatio === 0
            ? zero
              ? transitionZero.toFixed(2)
              : diff.toFixed(2)
            : zero
              ? transitionZero.toFixed(2)
              : (diff * record.transformationRatio).toFixed(2)}
        </span>
       </HtmlTooltip>
      ) : !value || value === null || value[`volume-${index}`] === undefined ? (
       0
      ) : record.transformationRatio === null ||
        record.transformationRatio === 0 ? (
       zero ? (
        transitionZero.toFixed(2)
       ) : (
        diff.toFixed(2)
       )
      ) : zero ? (
       transitionZero.toFixed(2)
      ) : (
       (diff * record.transformationRatio).toFixed(2)
      )}
     </div>
    );
   },
  },
  {
   title: 'Единица измерения',
   dataIndex: ['measureUnit'],
   render(_, record) {
    return {
     children: record.measureUnit,
    };
   },
  },
  {
   title: 'Переход через ноль',
   dataIndex: ['measureUnit'],
   render(_, record, index) {
    return (
     <Form.Item valuePropName="checked" name={`zero-${index}`}>
      <Checkbox
       value={checked}
       onChange={(value: any) => {
        onChange(value);
       }}
      />
     </Form.Item>
    );
   },
  },

  ...(hasAskueData
   ? [
      {
       title: '',
       dataIndex: 'currentReading',
       render: (val, record, index) => {
        if (!record?.askue) return null;
        return (
         <div style={{ display: 'inline-block' }}>
          <Form.Item
           name={`volume-${index}`}
           initialValue={record.currentReading}
           noStyle
          >
           <input type="hidden" />
          </Form.Item>

          <Link
           component="button"
           type="button"
           disabled={false}
           onClick={handleLinkClick}
           underline={'always'}
           sx={{
            fontSize: '0.875rem',
            cursor: 'pointer',
            color: 'primary.main',
            verticalAlign: 'baseline',
            p: 0,
            background: 'none',
            border: 'none',
            textAlign: 'left',
           }}
          >
           Подробнее
          </Link>
         </div>
        );
       },
      },
     ]
   : []),
 ];

 return (
  <>
   <ConnectHeader>
    <Header>
     <ConnectName>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
       <div>{connect?.name}</div>
       <div style={{ color: 'red', marginLeft: '10px', fontWeight: 200 }}>
        {showButton
         ? ``
         : `Только просмотр. Период передачи показаний еще не наступил.`}
       </div>
      </div>
     </ConnectName>
     {connect?.inputPeriodStart !== null &&
     connect?.inputPeriodStop !== null ? (
      <ConnectPeriod>
       Период передачи показаний с{' '}
       {`${moment(connect?.inputPeriodStart).format('D')} по ${moment(
        connect?.inputPeriodStop,
       ).format('D')} число`}
      </ConnectPeriod>
     ) : null}
    </Header>
   </ConnectHeader>
   <Underline />
   <TableReading
    rowKey={(record) => record.id}
    columns={columns}
    rowClassName={() => 'editable-row'}
    dataSource={createNewArr(meterings)}
    loading={isLoading}
    pagination={false}
   />
   <SubmitButton
    htmlType="submit"
    loading={isSubmiting}
    onClick={() => form.submit()}
    disabled={(check === true ? false : true) || processData || !showButton}
   >
    Передать показания
   </SubmitButton>

   <Snackbar
    open={snackBarOpened}
    autoHideDuration={8000}
    onClose={handleSnackBarClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    style={{
     width: '400px',
     marginBottom: '18%',
    }}
   >
    <Alert
     onClose={handleSnackBarClose}
     severity={snackBarType}
     sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      justifyItems: 'center',
      alignContent: 'center',
      alignItems: 'center',
      width: '100%',
      border: '1px red solid',
      backgroundColor: '#F5F3F2',
      color: 'black',
      fontWeight: 100,
      fontSize: '14px',
      height: '100px',
      overflow: 'hidden',
      borderRadius: '10px',
     }}
    >
     {snackBarMessage}
    </Alert>
   </Snackbar>
  </>
 );
}
